const newEventPresenter = require('./eventPresenter');
const {
    deactivate
} = require('gui');

module.exports = function eventsPresenter(eventsDto) {
    const view = require('./eventsPresenter.tpl.html');
    const c = {};
    const deactivator = deactivate();

    c.activate = function(region) {
        view.activate(region);

        eventsDto.forEach((event,i) => {
            let presenter = newEventPresenter(event);
            presenter.activate(view.eventsRegion);
            deactivator.add(presenter);
        });
    };

    c.deactivate = function() {
        deactivator();
        view.deactivate();
    }
    return c;
};
